import cn from 'classnames';
/* Class assignment */
export var genericModalClass = function (className, isMaxWidthCustom, ifFullwidth) {
    return cn(className, 
    /* Modal (base) */
    'inline-block p-8 transform overflow-hidden bg-gray-800', 'rounded-xl shadow-xl flex-column transition-all ', 'sm:align-middle sm:my-8', ifFullwidth && 'sm:w-full', !isMaxWidthCustom && 'sm:max-w-3xl');
};
